import { Panel } from "@/components/staff/Panel";
import PerfView from "@/components/perf/PerfView";
import { MyAttendance } from "@/components/hr/MyAttendance";
import { MyLeave } from "@/components/hr/MyLeave";
import { MyTargets } from "@/components/hr/MyTargets";
import "@/ch.css";

export default function MyWorkspace() {
  return (
    <div data-testid="my-workspace">
      <Panel id="me" title="My Workspace" sub="Your performance, targets, attendance and leave. Only you and the System Admin can see your records." tabs={[
        { k: "perf", l: "Performance", el: <div className="ch chs phd" data-testid="my-performance"><PerfView /></div> },
        { k: "targets", l: "Targets", el: <div className="ch chs phd"><MyTargets /></div> },
        { k: "attendance", l: "Attendance", el: <div className="ch chs phd"><MyAttendance /></div> },
        { k: "leave", l: "Leave", el: <div className="ch chs phd"><MyLeave /></div> },
      ]} />
    </div>
  );
}
